import $ from 'jquery';
// import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/password-caps-lock-warning.hbs';
  
   // var globalCh = Radio.channel('global');

  export default Marionette.View.extend({
    template : Handlebars.compile(template),
    ui: {
        inputField: 'input',
        caps_lock_warning: '.caps-lock-warning',
    },
    events: {
        'keypress @ui.inputField' : 'show_warning_sign_for_caps_lock',
    },
    initialize: function(options) {
        this.next = options.next;
    },
    onRender: function () {
  
    },
    show_warning_sign_for_caps_lock: function(e) {
        var s = String.fromCharCode( e.which );
        this.ui.caps_lock_warning.hide();
        $(".caps-lock-warning").hide();
        if ( s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey ) {
            return $(".caps-lock-warning").show();
        } else {
            return $(".caps-lock-warning").hide();
        }         
    },
  });










